export default {
  'menu.account': 'Account Security',
  'pages.account.action.changePassword': 'Change password',
  'pages.account.action.logout': 'Logout',
  'pages.account.action.refresh': 'Refresh',
  'pages.account.action.register': 'Register',
  'pages.account.currentAdmin': 'Current admin',
  'pages.account.field.confirmPassword': 'Confirm password',
  'pages.account.field.password': 'Password',
  'pages.account.field.username': 'Username',
  'pages.account.logout.confirm': 'Log out of this account?',
  'pages.account.message.saved': 'Done',
  'pages.account.password.title': 'Change password',
  'pages.account.register.title': 'Register admin',
  'pages.account.title': 'Account Security',
  'pages.account.validation.confirmRequired': 'Please confirm the password',
  'pages.account.validation.passwordMismatch': 'The two passwords do not match',
  'pages.account.validation.passwordRequired': 'Password is required',
  'pages.account.validation.passwordStrong':
    'Password must be at least 8 characters and include uppercase and lowercase letters, a number, and a special character, with no spaces.',
  'pages.account.validation.usernameRequired': 'Username is required',
};
